import {
  copyTextToClipboard,
  formatCatalogModuleTree,
} from './formatProductCatalogStructureForCopy';

export { copyTextToClipboard };

function formatExistingFiltersList(filters = []) {
  const published = filters.filter((filter) => !filter.archived);
  const archived = filters.filter((filter) => filter.archived);

  if (!filters.length) {
    return '(nenhum filtro criado ainda)';
  }

  const lines = [];

  if (published.length) {
    lines.push('Publicados:');
    published.forEach((filter) => lines.push(`- ${filter.name}`));
  }

  if (archived.length) {
    if (lines.length) lines.push('');
    lines.push('Arquivados:');
    archived.forEach((filter) => lines.push(`- ${filter.name}`));
  }

  return lines.join('\n');
}

/**
 * Prompt + estrutura do catálogo para colar em IA externa e sugerir Filtros Inteligentes.
 */
export function buildGlobalCatalogFiltersAiAssistantText(
  tree = [],
  filters = [],
  { prefilterByTagFirst = false } = {}
) {
  const moduleTree = formatCatalogModuleTree(tree);
  const filtersList = formatExistingFiltersList(filters);

  const openModeBlock = prefilterByTagFirst
    ? `Configuração do app: Abrir pré-filtrado — o catálogo já abre com o primeiro filtro aplicado. Módulos que não estiverem em nenhum filtro ficam invisíveis para o aluno na abertura (e enquanto um filtro estiver selecionado).`
    : `Configuração do app: Abrir catálogo completo — o aluno vê todo o conteúdo ao abrir e escolhe o filtro quando quiser.`;

  const thinkingBullet = prefilterByTagFirst
    ? '- Prefira poucos filtros enxutos; um módulo pode entrar em mais de um filtro\n- OBRIGATÓRIO: todo módulo da lista precisa entrar em pelo menos um filtro — não deixe nenhum de fora'
    : '- Prefira poucos filtros enxutos; um módulo pode entrar em mais de um filtro, ou não entrar em nenhum (visível apenas quando nenhum filtro está selecionado)';

  const coverageRule = prefilterByTagFirst
    ? '- Com "Abrir pré-filtrado", TODOS os módulos de TODAS as categorias precisam estar em pelo menos um filtro'
    : null;

  const unassignedSection = prefilterByTagFirst
    ? `2) Módulos sem filtro (não deve haver nenhum nesta configuração — se algum ficou de fora, liste para revisão):

- Módulo: … — Categoria: …
(ou "Nenhum — todos os módulos foram atribuídos")`
    : `2) Não aplicado em nenhum filtro, aparece quando nenhum filtro é selecionado:

- Módulo: … — Categoria: …
(ou "Nenhum")`;

  const rulesBlock = [
    '- Não inclua o filtro "Todos" — o catálogo completo já aparece quando nenhum filtro está selecionado',
    coverageRule,
    '- Nomes de filtro: até 3 palavras, sem caracteres especiais',
    '- Evite filtros por mês ou data (o catálogo cresce e a barra fica enorme)',
    '- Ao LISTAR o que entra em cada filtro, use somente categorias e módulos da lista acima, com título COPIADO LITERALMENTE',
    '- Em cada linha de módulo, informe a categoria pai (título literal da lista)',
  ]
    .filter(Boolean)
    .join('\n');

  const summaryLine = prefilterByTagFirst
    ? 'Resumo: nomes dos filtros = livres e orientados ao aluno; títulos de categorias e módulos na resposta = exatos da lista, com categoria em toda linha de módulo; cobertura total obrigatória — nenhum módulo pode ficar sem filtro.'
    : 'Resumo: nomes dos filtros = livres e orientados ao aluno; títulos de categorias e módulos na resposta = exatos da lista, com categoria em toda linha de módulo, para o admin marcar nos checkboxes do painel Filtros.';

  return `Tenho um app de conteúdo com catálogo de categorias e módulos. Preciso configurar os Filtros do catálogo (Filtros Inteligentes) — tags que o aluno usa para filtrar o conteúdo na tela principal.

${openModeBlock}

Filtros já criados no painel:
${filtersList}

Estrutura do catálogo (categorias e módulos):
${moduleTree}

Sugira filtros para o catálogo do app.

Como pensar:
- Crie nomes de filtro pensando em como o ALUNO busca conteúdo (tema, tipo, intenção) — podem ser criativos e NÃO precisam repetir as categorias administrativas
- Interprete os títulos dos módulos para agrupar por tema, mesmo quando estão em categorias diferentes
${thinkingBullet}

Regras:
${rulesBlock}

Formato da resposta (obrigatório, em português). Use estes rótulos e a estrutura; preencha com os dados reais da lista:

1) Para cada filtro sugerido:

Filtro: …
- Categoria: … (todos os módulos)
- Módulo: … — Categoria: …

${unassignedSection}

3) Filtros do catálogo:

… · … · …
(apenas os nomes dos filtros sugeridos acima)

4) Observações (opcional):

…

${summaryLine}`;
}
